<script setup lang="ts">
import {computed} from 'vue';

const props = withDefaults(
  defineProps<{
    indicatorClass?: string | object;
    trackClass?: string | object;
    value: number;
    height: number | string;
  }>(),
  {
    indicatorClass: 'bg-blue-600 dark:bg-blue-400',
    trackClass: 'bg-gray-200 dark:bg-gray-700 h-1',
    height: 3,
  }
);

const computedHeight = computed(() => {
  if (typeof props.height === 'number') {
    return `${props.height}px`;
  }

  return props.height;
});
</script>

<template>
  <div
    class="track"
    :class="trackClass"
    :style="{
      height: computedHeight,
    }"
  >
    <div
      class="indicator"
      :style="{
        width: `${value}%`,
      }"
      :class="indicatorClass"
    ></div>
  </div>
</template>

<style scoped>
.track {
  width: 100%;
  border-radius: 2px;
  position: relative;
}

.indicator {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
}
</style>
